import { render, staticRenderFns } from "./goodsStockEdit.vue?vue&type=template&id=b68832ce&scoped=true"
import script from "./goodsStockEdit.vue?vue&type=script&lang=js"
export * from "./goodsStockEdit.vue?vue&type=script&lang=js"
import style0 from "./goodsStockEdit.vue?vue&type=style&index=0&id=b68832ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68832ce",
  null
  
)

export default component.exports